export default __webpack_public_path__ + "static/media/bow.56f12519.png";